/**
 * Gospel Noir — Scroll-Scrubbed Video Helper
 * 
 * Works with the sticky-pin pattern:
 *   .section  { position: relative; height: 300vh; }
 *   .pin      { position: sticky; top: 0; height: 100vh; }
 *   video     { width:100%; height:100%; object-fit:cover; }
 *
 * Progress formula for sticky:
 *   0 = pin just locked to top
 *   1 = section bottom about to exit (pin unlocks)
 */
function gnInitScrollVideo(section, video, onProgress) {
  if (!section || !video) return;

  video.muted        = true;
  video.playsInline  = true;
  video.preload      = 'none';
  video.loop         = false;

  var active    = false;
  var locked    = false;
  var rafId     = null;
  var current   = 0;

  function computeProgress() {
    var rect = section.getBoundingClientRect();
    var vh   = window.innerHeight || document.documentElement.clientHeight;
    // Correct formula for sticky-pin sections
    var scrollable = rect.height - vh;          // how far the section scrolls
    var progress   = scrollable > 0 ? -rect.top / scrollable : 0;
    return Math.max(0, Math.min(1, progress));
  }

  function loop() {
    if (!active) { rafId = null; return; }

    var p = computeProgress();

    if (!locked && video.readyState >= 2 && video.duration) {
      var target = p * video.duration;
      var diff   = target - current;
      // Gentle ease — smooth but responsive
      if (Math.abs(diff) > 0.016) {
        current += diff * 0.14;
        video.currentTime = current;
      }
    }

    if (typeof onProgress === 'function') {
      onProgress(p,
        function() { locked = true;  },   // lockVideo()
        function() { locked = false; }    // unlockVideo()
      );
    }
    rafId = requestAnimationFrame(loop);
  }

  var loaded = false;
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        if (!loaded) { video.preload = 'auto'; loaded = true; }
        active = true;
        video.style.display = 'block';
        if (!rafId) rafId = requestAnimationFrame(loop);
      } else {
        active  = false;
        locked  = false;
        current = video.currentTime;
        video.style.display = 'none';
        if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      }
    });
  }, { threshold: 0.01 });

  io.observe(section);
}
